import React, { useState, useCallback, useEffect } from 'react';
import { Button, TextField, Flex, Text, Spinner, Card, Box, Avatar } from '@radix-ui/themes';
import { debounce } from 'lodash';
import api from '../../api';
import { ArrowRightIcon, Cross2Icon } from '@radix-ui/react-icons';
const SchoolSearch = ({ onSelect, selectedSchoolId }) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [schoolResults, setSchoolResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedSchool, setSelectedSchool] = useState(null);

    // Debounced search function
    const fetchSchools = useCallback(
        debounce(async (query) => {
            if (!query.trim()) {
                setSchoolResults([]);
                return;
            }
            setLoading(true);
            try {
                const response = await api.get(`/search-schools`, { params: { search_query: query } });
                setSchoolResults(response.data);
            } catch (error) {
                console.error('Error fetching schools:', error);
            } finally {
                setLoading(false);
            }
        }, 1000),
        []
    );

    // Effect to trigger search
    useEffect(() => {
        fetchSchools(searchQuery);
    }, [searchQuery, fetchSchools]);

    const handleSchoolSelect = (e, school) => {
        e.preventDefault();
        setSelectedSchool(school);

    }

    useEffect(() => {
        console.log('selectedSchool >>>>>>>>>>>>>>>', selectedSchool);
        onSelect(selectedSchool?.id || null);
    }, [selectedSchool]);

    if (selectedSchool !== null) {
        return (
            <Card variant="classic" style={{ backgroundColor: 'var(--grass-9)' }}>
                <Flex direction="row" justify="between" gap="3" align="center">
                    {selectedSchool.crest != '' && <Avatar size="3"
                        src={`${import.meta.env.VITE_PUBLIC_URL}/storage/${selectedSchool.crest}`}
                        fallback={<Avatar
                            size="3"
                            src={'/images/defaultCrest.png'}

                        />}
                    />}
                    <Box style={{ flex: 1 }}>
                        <Text as="p" size="1" weight="bold" color="var(--gray-12)">{selectedSchool.name}</Text>
                        <Text as="p" size="1">{selectedSchool.location}</Text>
                    </Box>
                    <Button variant="ghost" color="gray" onClick={() => setSelectedSchool(null)}>
                        <Cross2Icon />
                    </Button>
                </Flex>
            </Card>
        )
    }
    return (
        <Flex direction="column" gap="3" align="start" width="100%">
            <TextField.Root
                size="3"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search for your school"
                style={{width: '100%'}}
            />
            {loading && <Spinner size="3" />}
            {schoolResults.length > 0 && (
                <Flex direction="column" gap="2" width="100%">
                    {schoolResults.map((school) => (
                        <Card
                            className='cursor-pointer hoverBgLight'
                            key={school.id}
                            variant={selectedSchoolId === school.id ? 'solid' : 'soft'}
                            color={selectedSchoolId === school.id ? 'green' : 'gray'}
                            onClick={(e) => handleSchoolSelect(e, school)}
                        >
                            <Flex direction="row" gap="4" align="center">
                                {school.crest != '' && <Avatar
                                    size="3"
                                    src={`${import.meta.env.VITE_PUBLIC_URL}/storage/${school.crest}`}
                                    fallback={<Avatar
                                        size="3"
                                        src={'/images/defaultCrest.png'}

                                    />}
                                />}
                                <Box style={{ flex: 1 }}>
                                    <Text as="p" size="1" weight="bold">{school.name}</Text>
                                    <Text as="p" size="1">{school.location}</Text>
                                </Box>
                                <ArrowRightIcon />
                            </Flex>
                        </Card>
                    ))}
                </Flex>
            )}
            {!loading && searchQuery && schoolResults.length === 0 && (
                <Text size="2" color="gray">
                    No schools found for "{searchQuery}"
                </Text>
            )}
        </Flex>
    );
};

export default SchoolSearch;
